/**
 * Onboarding-related constants.
 * 
 * @author vikram singh <vikram@maropost.com>
 * @created 2026-01-20
 */

/**
 * Key for the overall onboarding completion status.
 */
export const ONBOARDING_COMPLETED_KEY = 'onboarding'

/**
 * Valid onboarding status values.
 */
export const ONBOARDING_VALID_STATUSES = ['completed', 'in_progress', 'not_started'] as const
